export const BUTTON_TYPES = {
    EMAIL: 'email',
    PHONE: 'phone',
    EMAIL_AND_PHONE: 'email_and_phone',
    NONE: '',
};
export const BUTTON_IDS = {
    main: 'show-details-button-id',
    phone: 'show-phone-icon-button-id',
    email: 'show-email-icon-button-id',
};
